<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading"></div>
        <div class="widget-content">
		  <div class="row align-items-center mb-2">
		    <div class="col-12 col-sm-6 mb-2 mb-sm-0">
			  <h3 class="mb-0">Miesiąc: {{ monthNames[selectedMonth - 1] }}</h3>
		    </div>
		    <div class="col-12 col-sm-6 d-flex flex-column flex-sm-row justify-content-sm-end">
			  <button class="btn btn-sm btn-outline-secondary me-0 me-sm-2 mb-2 mb-sm-0" 
					@click="changeMonth(-1)">← Poprzedni</button>
			  <button class="btn btn-sm btn-outline-secondary" 
					@click="changeMonth(1)">Następny →</button>
		    </div>
		  </div>
          <div class="row align-items-center mb-2">
			<div class="col-sm-6 col-md-6 col-lg-3 d-flex">
			  <select v-model="selectedMonth" class="form-select mb-2" @change="onMonthChange">
				<option v-for="m in 12" :key="m" :value="m">{{ monthNames[m - 1] }}</option>
			  </select>
			</div>
			<div class="col-sm-6 col-md-6 col-lg-3 d-flex">
			  <select v-model="selectedYear" class="form-select mb-2" @change="loadSelectedWeek">
				<option v-for="year in yearRange" :key="year" :value="year">{{ year }}</option>
			  </select>
			</div>
			<div class="col-auto ms-auto d-flex"> 
			  <a :href="route('worktime-users.generatePdfWorkHoursP', { year: formattedMonth2.split('-')[0], month: formattedMonth2.split('-')[1], id: myid})"
				   class="btn btn-outline-info btn-sm equal-width-btn me-2">
				  <i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz podsumowanie
			  </a>
			  <a :href="route('worktime-users.viewPdfWorkHoursP', { year: formattedMonth2.split('-')[0], month: formattedMonth2.split('-')[1], id: myid})"
				   rel="noopener noreferrer" target="_blank" class="btn btn-outline-info btn-sm equal-width-btn">
				  <i class="bi bi-eye"></i>&nbsp;Podgląd podsumowania
			  </a>
			</div>
		  </div>
	  
		  <div class="row mb-2">
			<div class="col-12">
			  <div class="alert alert-success">
				<h5>Podsumowanie godzin pracy: <strong>{{ calculateTotalWorkHours() }}</strong></h5>
			  </div>
			</div>
		  </div>  
	  
		  <div class="alert alert-danger mb-2" v-if="lockedStatus">
			<strong>Uwaga!</strong> Podany okres został zablokowany przez pracownika biura. Edycja danych oraz dodawanie wpisów nie jest możliwe.
		  </div>

		<div class="table-responsive">
		  <button v-if="!lockedStatus" @click="addNew" class="btn btn-primary btn-sm mb-2">Dodaj wpis</button>
		  <table class="table table-bordered table-hover">
			<thead>
			  <tr>
				<th>#</th>
				<th>Projekt</th>
				<th>Opis</th>
				<th>Liczba godzin</th>
				<th>Akcje</th>
			  </tr>
			</thead>
			<tbody>
			  <tr v-for="(entry, index) in weekEntries" :key="entry.id || index">
				<td>{{ index + 1 }}</td>
				<td>{{ entry.project_number || '—' }}</td>
				<td>
				  <p class="mb-0">{{ entry.description || '—' }}</p>
				  <span v-if="entry.project_endet == 1" class="badge bg-success mt-1">Projekt zakończony</span>
				</td>
				<td>{{ entry.hours || '--:--' }}</td>
				<td class="d-flex flex-column flex-sm-row gap-1">
				  <button v-if="!lockedStatus" @click="editEntry(entry)" class="btn btn-sm btn-primary">Edytuj</button>
				  <button v-if="!lockedStatus" @click="deleteEntry(entry)" class="btn btn-sm btn-danger">Usuń</button>
				</td>
			  </tr>
			  <tr v-if="weekEntries.length === 0">
				<td colspan="5" class="text-center">Brak wpisów</td>
			  </tr>
			</tbody>
		  </table>
		</div>

		<div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.5);">
		  <div class="modal-dialog modal-lg">
			<div class="modal-content">
			  <div class="modal-header">
				<h5 class="modal-title">{{ modalMode === 'add' ? 'Dodaj wpis' : 'Edytuj wpis' }}</h5>
				<button type="button" class="btn-close" @click="closeModal"></button>
			  </div>
			  <div class="modal-body">
				<div class="mb-3">
				  <label for="projectNumber" class="form-label">Numer projektu:</label>
				  <input id="projectNumber" v-model="currentEntry.project_number" type="text" class="form-control">
				</div>
				<div class="mb-3">
				  <label for="description" class="form-label">Opis:</label>
				  <textarea id="description" v-model="currentEntry.description" class="form-control"></textarea>
				</div>
				<div class="form-check mb-3">
				  <input type="checkbox" class="form-check-input" id="projectEndet" v-model="currentEntry.project_endet" :true-value="1" :false-value="0">
				  <label class="form-check-label" for="projectEndet">Projekt zakończony</label>
				</div>
				<div class="mb-3">
				  <label for="hours" class="form-label">Liczba godzin:</label>
				  <input id="hours" type="text" v-model="currentEntry.hours" placeholder="00:00" maxlength="5" class="form-control">
				</div>
			  </div>
			  <div class="modal-footer">
				<button class="btn btn-success" @click="saveEntry">Zapisz</button>
				<button class="btn btn-secondary" @click="closeModal">Anuluj</button>
			  </div>
			</div>
		  </div>
		</div>
		  
          <div class="row">
            <div class="col-md-12 col-lg-12">
			  <div class="mb-2">
				<h4 class="me-3 my-0">Pliki:</h4>
			  </div>
			  <ul class="list-group me-3 mt-3 mb-3 w-100">
				<li class="list-group-item fw-bold bg-light d-none d-sm-block" v-if="localServiceFiles.length > 0">
				  <div class="row">
					<div class="col-12 col-sm-6 col-md-5">Nazwa pliku</div>
					<div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
					<div class="col-12 col-sm-2 col-md-3 text-end">Opcje</div>
				  </div>
				</li>
				<li v-if="isLoadingFiles" class="list-group-item border-0">
				  <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">Ładowanie...</div>
				</li>
				<li class="list-group-item" v-else v-for="file in localServiceFiles" :key="file.id">
				  <div class="row align-items-center">
					<div class="col-12 col-sm-6 col-md-5 text-break">{{ file.name }}</div>
					<div class="col-12 col-sm-4 col-md-4 text-muted small"><i>{{ formatDate(file.created_at) }}</i></div>
					<div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
					  <div class="d-inline-flex">
						<a class="btn btn-sm btn-outline-info me-2" :href="route('worktime-files.download', [file.id, file.user_id])" download><i class="bi bi-download me-1"></i>Pobierz</a>
						<button v-if="!lockedStatus" class="btn btn-sm btn-outline-danger" @click="deleteFile(file)" type="button"><i class="bi bi-trash me-1"></i>Usuń</button>
					  </div>
					</div>
				  </div>
				</li>
				<li class="list-group-item" v-if="localServiceFiles.length <= 0 && !isLoadingFiles"><i>Brak plików</i></li>
			  </ul>
			</div>
			  
<form @submit.prevent="submitForm">
  <div class="row gap-3" v-if="!lockedStatus">
    <div class="col-12">
      <label for="attachments">Dodaj pliki:</label>

      <div v-if="isLoading" class="mt-3">
        <div class="progress" style="height: 8px;">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: uploadProgress + '%' }"></div>
        </div>
        <small class="text-muted">{{ uploadProgress }}%</small>
      </div>
      <input type="file" id="attachments" multiple @change="handleFileUpload" class="form-control form-control-sm" ref="fileInput" />
      <div v-if="form.attachments.length" class="mt-2">
        <p>Załączone pliki:</p>
        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(file, index) in form.attachments" :key="index">
            {{ file.name }}
            <button type="button" class="btn btn-sm btn-danger" @click="removeFile(index)">Usuń</button>
          </li>
        </ul>
      </div>
      <div class="mt-3">
        <button type="submit" class="btn btn-primary" :disabled="isLoading">
          {{ isLoading ? 'Wysyłanie...' : 'Dodaj pliki' }}
        </button>
      </div>
      <div v-if="uploadError" class="alert alert-danger mt-2 py-1">
        {{ uploadError }}
      </div>
    </div>
  </div>
</form>

          </div>

	    </div>		
	  </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { router } from "@inertiajs/vue3";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import { Tooltip } from 'bootstrap';
import { isDisabled } from "bootstrap/js/src/util/index.js";

export default {
  components: { AppLayout },
  props: {
    workData: {
      type: Array,
      default: () => [],
    },
    locked: {
      type: Boolean,
      default: false,
    },
	myid: {
      type: Number,
      default: null,
    },
    week: {
      type: Number,
      default: null,
    },
    year: {
      type: Number,
      default: null,
    },
    month: {
      type: Number,
      default: null,
    },
  },
  data() {
    const now = new Date();
    return {
      selectedYear: this.year ?? now.getFullYear(),
	  selectedMonth: this.month !== null ? this.month : (now.getMonth() + 1),
    monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],

      selectedWeek: this.week ?? this.getWeekNumber(now),
      yearRange: Array.from({ length: 10 }, (_, i) => now.getFullYear() - 5 + i),
      weekEntries: this.workData || [],
      editingId: null,
      addingNew: false,
      lockedStatus: this.locked || false,
	  myid: this.myid || '',
      newEntry: { project_number: '', description: '', hours: '', project_endet: 0 },
      isInitialLoad: true,
	  isEditing: {},
	  isLoadingFiles: false,
      localServiceFiles: [], 
      form: {
        attachments: [],
      },
    isModalOpen: false, 
    modalMode: null, 
	isLoading: false,
	isProcessing: false,
	uploadProgress: 0,
    uploadError: null,
    uploadSuccess: false,
    currentEntry: null, 
    };
  },
  computed: {
    formattedWeekRange() {
      const { start, end } = this.getWeekDateRange(this.selectedYear, this.selectedWeek);
      return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
    },
		formattedMonth2() {
    return `${this.selectedYear}-${String(this.getMonthFromWeek(this.selectedYear, this.selectedWeek)).padStart(2, '0')}`;
  }
  },
  mounted() {
    this.isInitialLoad = false;
	 this.fetchFiles(); 
  },
  methods: {
  
  addNew() {
    this.modalMode = 'add';
    this.currentEntry = { project_number: '', description: '', hours: '', project_endet: false };
    this.isModalOpen = true;
  },

  editEntry(entry) {
    this.modalMode = 'edit';
    this.currentEntry = { ...entry }; // kopiujemy, żeby nie nadpisywać tabeli zanim zapiszesz
    this.isModalOpen = true;
  },

  closeModal() {
    this.isModalOpen = false;
    this.currentEntry = null;
    this.modalMode = null;
  },

  onMonthChange() {
    this.selectedWeek = this.getMiddleWeekOfMonthStrict(this.selectedYear, this.selectedMonth);
    this.loadSelectedWeek();
  },
getMiddleWeekOfMonthStrict(year, month) {
	const middleDate = new Date(year, month - 1, 15); 
    return this.getWeekNumber(middleDate); 
},

	formatAsTime(entry) {
	  let raw = entry.hours.replace(/\D/g, ''); 

	  if (raw.length >= 3) {
		const hours = raw.slice(0, raw.length - 2);
		const minutes = raw.slice(-2);
		entry.hours = `${hours}:${minutes}`;
	  } else {
		entry.hours = raw;
	  }
	},
	
	normalizeHours(hours) {
	  if (!hours) return '00:00'; 
	  if (!hours.includes(':')) {
	  return hours + ':00';
	  }
	  const parts = hours.split(':');
	  let h = parts[0] || '00';
	  let m = parts[1] || '00';

	  if (m.length === 1) m = m + '0'; 

	  return `${h}:${m.padStart(2, '0')}`;
	},
  calculateTotalWorkHours() {
    let totalMinutes = 0;

    for (let entry of this.weekEntries) {
      const time = entry.hours;
      if (!time) continue;

      const [h, m] = time.split(':').map(Number);
      totalMinutes += h * 60 + m;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  },
  
    formatDate (dateString){
  if (!dateString) return ''; 
  let localDate = new Date(dateString); 
  const timezoneOffset = localDate.getTimezoneOffset();
  localDate.setMinutes(localDate.getMinutes() - timezoneOffset);
  return localDate.toISOString().split('T')[0];
},

  formatTime(time) {
    if (!time) return '';
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`;  
  },
    getWeeksInYear(year) {
      const d = new Date(year, 11, 31);
      const week = this.getWeekNumber(d);
      return week === 1 ? 52 : week;
    },
    getMonthFromWeek(year, week) {
      const date = new Date(year, 0, 1 + (week - 1) * 7);
      return date.getMonth() + 1;
    },
    getWeekNumber(date) {
      const target = new Date(date.valueOf());
      const dayNr = (date.getDay() + 6) % 7;
      target.setDate(target.getDate() - dayNr + 3);
      const firstThursday = new Date(target.getFullYear(), 0, 4);
      const diff = target - firstThursday;
      return 1 + Math.round(diff / 604800000);
    },
    getWeekDateRange(year, week) {
      const simple = new Date(year, 0, 1 + (week - 1) * 7);
      const dayOfWeek = simple.getDay();
      const ISOweekStart = new Date(simple);
      ISOweekStart.setDate(simple.getDate() - (dayOfWeek <= 0 ? 6 : dayOfWeek - 1));
      const ISOweekEnd = new Date(ISOweekStart);
      ISOweekEnd.setDate(ISOweekStart.getDate() + 4);
      return { start: ISOweekStart, end: ISOweekEnd };
    },
	changeMonth(zmiana) {
	  console.log("Wywołano changeMonth z zmiana:", zmiana);
	  console.log("Aktualny miesiąc:", this.selectedMonth);
	  console.log("Aktualny rok:", this.selectedYear);

	  let newMonth = this.selectedMonth + zmiana;
	  let newYear = this.selectedYear;

	  if (newMonth < 1) {
		newMonth = 12;
		newYear--;
	  } else if (newMonth > 12) {
		newMonth = 1;
		newYear++;
	  }

	  console.log("Nowy miesiąc po zmianie:", newMonth);
	  console.log("Nowy rok po zmianie:", newYear);

	  this.selectedYear = newYear;
	  this.selectedMonth = newMonth;

	this.selectedWeek = this.getMiddleWeekOfMonthStrict(this.selectedYear, this.selectedMonth);

	  console.log("Ustawiony tydzień (middle week):", this.selectedWeek);

	  this.loadSelectedWeek();
	},

	toggleEdit(dateStr) {
		  this.isEditing[dateStr] = !this.isEditing[dateStr];
	},
	
    deleteEntry(entry) {
	if (!entry.id) return;
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie godzin',
        html: 'Czy na pewno chcesz usunąć ten wpis?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
         axios.delete(route('worktime-users.destroy', { id: entry.id }))
		  .then(() => {
			this.loadSelectedWeek(); 
			this.showToast('success', 'Usunięto', 'Wpis został usunięty.');
		  })
		  .catch(() => {
			this.showToast('error', 'Błąd', 'Nie udało się usunąć wpisu.');
		  });
        }
      });
    },
	
  async saveEntry() {
  this.selectedWeek = this.getMiddleWeekOfMonthStrict(this.selectedYear, this.selectedMonth);
    this.currentEntry.hours = this.normalizeHours(this.currentEntry.hours);
    if (!/^\d{1,3}:\d{2}$/.test(this.currentEntry.hours)) {
      Toast.fire({ icon: 'error', title: 'Błąd', html: 'Niepoprawny format godzin (HH:MM)' });
      return;
    }

    if (this.modalMode === 'add') {
      const payload = { year: this.selectedYear, week: this.selectedWeek, ...this.currentEntry };
      await router.post(route('worktime.store'), payload, {
        preserveScroll: true,
        preserveState: true,
        onSuccess: async () => {
          this.closeModal();
          await this.loadSelectedWeek();
          Toast.fire({ icon: 'success', title: 'Dodano wpis', timer: 1500 });
        },
      });
    } else if (this.modalMode === 'edit') {
		const payload = { 
		  id: this.currentEntry.id,
		  project_number: this.currentEntry.project_number || '',
		  project_endet: this.currentEntry.project_endet ? '1' : '0', // tu konwersja
		  description: this.currentEntry.description || '',
		  hours: this.currentEntry.hours,
		  week: this.selectedWeek,
		  year: this.selectedYear
		};
      await router.put(route('worktime-users.update', { id: this.currentEntry.id }), payload, {
        preserveScroll: true,
        preserveState: true,
        onSuccess: async () => {
          this.closeModal();
          await this.loadSelectedWeek();
          Toast.fire({ icon: 'success', title: 'Zapisano zmiany', timer: 1500 });
        },
      });
    }
  },
  
loadSelectedWeek() {
 
 this.selectedWeek = this.getMiddleWeekOfMonthStrict(this.selectedYear, this.selectedMonth);

  axios.get(route('worktime.data'), {
    params: {
      year: this.selectedYear,
      week: this.selectedWeek,
      month:  this.selectedMonth
	  
    },
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(res => {
    this.weekEntries = res.data.workData || [];
    this.lockedStatus = res.data.locked || false;
	this.fetchFiles();
  })
  .catch(() => {
    this.weekEntries = [];
    this.lockedStatus = false;
	
  });
},


    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },
fetchFiles() {
  this.isLoadingFiles = true;
  axios.get(route('worktime-files.index'), {
    params: {
      year: this.selectedYear,
      //month: this.getMonthFromWeek(this.selectedYear, this.selectedWeek)
	  month: this.selectedMonth
    }
  }).then((response) => {
    this.localServiceFiles = response.data;
  }).finally(() => {
    this.isLoadingFiles = false;
  });
},
	handleFileUpload(event) {
	  this.uploadError = null;
	  const files = Array.from(event.target.files);

	  const maxSize = 100 * 1024 * 1024; // 100 MB
	  const validFiles = [];

	  for (let file of files) {
		if (file.size > maxSize) {
		  this.uploadError = `Plik "${file.name}" jest za duży (max 100 MB).`;
		} else if (file.size === 0) {
		  this.uploadError = `Plik "${file.name}" jest pusty.`;
		} else {
		  validFiles.push(file);
		}
	  }

	  if (validFiles.length > 0) {
		this.form.attachments.push(...validFiles);
	  }

	  this.$refs.fileInput.value = "";
	},
async submitForm() {
  this.uploadError = null;
  this.uploadProgress = 0;
  this.isLoading = true;

  if (this.form.attachments.length === 0) {
    this.uploadError = "Nie wybrano plików do wysłania.";
    this.isLoading = false;
    return;
  }

  const formData = new FormData();
  this.form.attachments.forEach(file => formData.append('attachments[]', file));
  formData.append('okres', this.formattedMonth2);

  try {
    await axios.post(route('worktime-files.store'), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      }
    });

    this.form.attachments = [];
    this.$refs.fileInput.value = "";
    this.uploadProgress = 100;
    await this.fetchFiles();

  } catch (error) {
    console.error("Błąd zapisu:", error);
    this.uploadError = error.response?.data?.message || "Wystąpił błąd podczas wysyłania pliku.";
  } finally {
    this.isLoading = false;
    setTimeout(() => this.uploadProgress = 0, 2000);
  }
},
	
    deleteFile(file) {
	if (!file.id) return;
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pliku',
        html: 'Czy na pewno chcesz usunąć ten plik?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
		 axios.delete(route('worktime-files.destroy', file.id))
		  .then(() => {
			this.fetchFiles(); 
			this.showToast('success', 'Usunięto', 'Plik został usunięty.');
		  })
		  .catch(() => {
			this.showToast('error', 'Błąd', 'Nie udało się usunąć pliku.');
		  });
        }
      });
    },
	
	showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
	
	
	
	
  },
};
</script>
<style scoped>
.today {
  background-color: #f8f9fa;
}
.weekend {
  background-color: #f0f0f0;
}
</style>